export default __webpack_public_path__ + "static/media/congratulation.6db1197b.png";